import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/components/common/messageservice';
import { ConfirmationService } from 'primeng/primeng';
import { CfcService } from '../cfc.service';

@Component({
  selector: 'sispac-gerenciar-termo-aditivo',
  templateUrl: './gerenciar-termo-aditivo-cfc.component.html',
  styleUrls: ['./gerenciar-termo-aditivo-cfc.component.css']
})
export class GerenciarTermoAditivoCfcComponent implements OnInit {

  idCfcUnidade;
  public dadosCfcUnidade;
  public termosAditivos;

  constructor(
    private fb: FormBuilder,
    public messageService: MessageService,
    private route: ActivatedRoute,
    private cfcService: CfcService,
    private confirmationService: ConfirmationService,
  ){

    this.route.paramMap
      .subscribe(params => {
        this.idCfcUnidade = params.get('idCfcUnidade');
        this.buscarDadosUnidadeECfc(this.idCfcUnidade);
        this.buscarTermosAditivos();
      });
  }

  ngOnInit() {
  }

  buscarDadosUnidadeECfc(idCfcUnidade){
    this.cfcService.getDadosCfcUnidade(idCfcUnidade).subscribe(
      data => {
        this.dadosCfcUnidade = data;
        console.log(data);
      });
  }

  buscarTermosAditivos(){
    this.cfcService.getTermosAditivos(this.idCfcUnidade).subscribe(
      data => {
        this.termosAditivos = data;
      });
  }


  excluir(idCfcTermoAditivo) {

    this.confirmationService.confirm( {
      message: 'Tem certeza que deseja excluir o item selecionado?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.cfcService.excluirTermoAditivo(idCfcTermoAditivo).subscribe(
          res => {
            this.buscarTermosAditivos();
        })
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/cfc/gerenciar-termo-aditivo-cfc/gerenciar-termo-aditivo-cfc.component.ts